import { useEffect } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AppShell } from "@/components/app-shell";
import { OpportunitiesPage } from "@/pages/opportunities";
import { OpportunityDetailPage } from "@/pages/opportunity-detail";
import { ProductsPage } from "@/pages/products";
import { ClientsPage } from "@/pages/clients";
import { ClientDetailPage } from "@/pages/client-detail";
import { ContactsPage } from "@/pages/contacts";
import { ContactDetailPage } from "@/pages/contact-detail";
import { PublicProposalPage } from "@/pages/public-proposal";
import { ProposalEditPage } from "@/pages/proposal-edit";
import { AccountingSystemsPage } from "@/pages/accounting-systems";
import { PromptsPage } from "@/pages/prompts";
import { SettingsLayout } from "@/pages/settings";
import { SettingsUsersPage } from "@/pages/settings/users";
import { SettingsIntegrationsPage } from "@/pages/settings/integrations";
import { SettingsLogsPage } from "@/pages/settings/logs";
import { SettingsTrackingPage } from "@/pages/settings/tracking";
import { SettingsOpportunityTagsPage } from "@/pages/settings/opportunity-tags";
import { SettingsPerksPage } from "@/pages/settings/perks";
import { SettingsCompanyPage } from "@/pages/settings/company";
import { SettingsContractTemplatesPage } from "@/pages/settings/contract-templates";
import { SettingsEmailTemplatesPage } from "@/pages/settings/email-templates";
import { SettingsTemplatesLayout } from "@/pages/settings/templates";
import { SettingsLemlistPage } from "@/pages/settings/lemlist";
import { SettingsAutomationsPage } from "@/pages/settings/automations";
import { Toaster } from "sonner";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* Public proposal page — its own minimal shell, no nav */}
        <Route path="/p/:slug" element={<PublicProposalPage />} />

        {/* Authed app routes — wrapped in AppShell with top nav */}
        <Route element={<AppShell />}>
          <Route path="/" element={<OpportunitiesPage />} />
          <Route path="/o/:id" element={<OpportunityDetailPage />} />
          <Route path="/o/:id/:tab" element={<OpportunityDetailPage />} />
          <Route path="/proposals/:id" element={<ProposalEditPage />} />
          <Route path="/clients" element={<ClientsPage />} />
          <Route path="/clients/:id" element={<ClientDetailPage />} />
          <Route path="/contacts" element={<ContactsPage />} />
          <Route path="/contacts/:id" element={<ContactDetailPage />} />
          <Route path="/lemlist" element={<SettingsLemlistPage />} />
          <Route path="/settings/lemlist" element={<Navigate to="/lemlist" replace />} />
          <Route path="/settings" element={<SettingsLayout />}>
            <Route index element={<Navigate to="users" replace />} />
            <Route path="users" element={<SettingsUsersPage />} />
            <Route path="company" element={<SettingsCompanyPage />} />
            <Route path="integrations" element={<SettingsIntegrationsPage />} />
            <Route path="contract-templates" element={<Navigate to="/settings/templates/contract" replace />} />
            <Route path="email-templates" element={<Navigate to="/settings/templates/email" replace />} />
            <Route path="templates" element={<SettingsTemplatesLayout />}>
              <Route index element={<Navigate to="contract" replace />} />
              <Route path="contract" element={<SettingsContractTemplatesPage />} />
              <Route path="email" element={<SettingsEmailTemplatesPage />} />
            </Route>
            <Route path="products" element={<ProductsPage />} />
            <Route path="accounting-systems" element={<AccountingSystemsPage />} />
            <Route path="opportunity-tags" element={<SettingsOpportunityTagsPage />} />
            <Route path="automations" element={<SettingsAutomationsPage />} />
            <Route path="perks" element={<SettingsPerksPage />} />
            <Route path="prompts" element={<PromptsPage />} />
            <Route path="tracking" element={<SettingsTrackingPage />} />
            <Route path="logs" element={<SettingsLogsPage />} />
          </Route>
        </Route>
      </Routes>
      <Toaster position="top-right" richColors />
    </>
  );
}
